module.exports = __webpack_public_path__ + "static/media/OrlandoHealth.70187341.png";